import {Amplify, Cache, Logger, Auth } from 'aws-amplify';

// Amplify.Logger.LOG_LEVEL = 'INFO';

import apiConfig from '@/library/api/config'
import { refrescarTokens } from '@/library/api/auth.js';


Auth.configure({ refreshHandlers: { developer: refrescarTokens } });